import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { createInviteByEmail } from '../lib/invite-by-email';
import { AdminInviteByEmailDialog } from './AdminInviteByEmailDialog';
import { OperatorRefusalAlert } from './OperatorRefusalAlert';
import { Button } from './ui/Button';

// "Invite by email" on `/admin` Users (plan 102 slice 05) — container. The one
// operator door that gives a friend their OWN account: invited, approved on accept,
// funded with the invite bundle (`lib/admin-provision.ts`). Never a member of the
// operator's account: that is the org Members invite, a different act. State in
// `lib/invite-by-email.ts`; `onInvited` re-reads the registry.

export function AdminInviteByEmail(props: {
  readonly token: string | null;
  readonly onInvited: () => void;
}): JSX.Element {
  const invite = createInviteByEmail(props.token, () => props.onInvited());
  return (
    <>
      <Button onClick={invite.open}>{t('admin.invite_email_cta')}</Button>
      <OperatorRefusalAlert refusal={invite.refusal()} />
      <AdminInviteByEmailDialog
        open={invite.isOpen()}
        busy={invite.busy()}
        error={invite.error()}
        result={invite.result()}
        onSend={invite.send}
        onClose={invite.close}
      />
    </>
  );
}
